import { GridColDef } from '@mui/x-data-grid';
import { Link } from '@mui/material';
import { DataGridLink } from '@carcareers/components';

import { routes } from '@carcareers/utils';

export const EMPLOYER_INDEX_COLUMNS: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70 },
  {
    field: 'name',
    headerName: 'Name',
    width: 200,
    renderCell: (params) => (
      <DataGridLink
        link={`/${routes.ADMIN_HOME}/${routes.ADMIN_EMPLOYERS_VIEW.replace(':id', params.row.id.toString())}`}
        content={`${params.row.user.firstName} ${params.row.user.lastName}`}
      />
    ),
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 250,
    valueGetter: (_, row) => row.user.email,
  },
  {
    field: 'phone',
    headerName: 'Phone Number',
    width: 200,
    valueGetter: (_, row) => row.user.phone,
  },
  {
    field: 'activeJobs',
    headerName: 'Active Jobs',
    width: 150,
  },
  {
    field: 'rooftopsOnboarded',
    headerName: 'Roof Tops',
    width: 150,
  },
  {
    field: 'updatedAt',
    headerName: 'Updated',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.updatedAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
  {
    field: 'createdAt',
    headerName: 'Joined',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.createdAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
];

export const EMPLOYER_INDEX_COLUMN_INITIAL_STATE = {
  id: true,
  name: true,
  email: true,
  phone: false,
  activeJobs: true,
  rooftopsOnboarded: true,
  createdAt: true,
  updatedAt: false,
};

export const EMPLOYER_INDEX_COLUMNS_INITIAL_STATE_MOBILE = {
  ...EMPLOYER_INDEX_COLUMN_INITIAL_STATE,
  phone: false,
  activeJobs: false,
  rooftopsOnboarded: false,
  createdAt: false,
  updatedAt: false,
};
